export const CITIES = ["جدة", "الرياض", "الدمام"];
export const PROPERTY_TYPES = ["فيلا", "شقة", "دوبلكس", "تاون هاوس", "أرض", "مكتب"];

export const PURPOSE_LABELS = { sale: "للبيع", rent: "للإيجار" };

export function formatPrice(price, purpose) {
  const n = new Intl.NumberFormat("ar-SA-u-nu-latn", { maximumFractionDigits: 0 }).format(price);
  return purpose === "rent" ? `${n} ر.س / سنوياً` : `${n} ر.س`;
}

export function formatNumber(n) {
  return new Intl.NumberFormat("ar-SA-u-nu-latn", { maximumFractionDigits: 0 }).format(n);
}

export function whatsappLink(number, text) {
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}

export const DEMO_DISCLAIMER = "نموذج تجريبي — جميع العقارات والبيانات المعروضة افتراضية";
